import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, actions } from 'react-redux-form';
import { Row, Col, Checkbox } from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredDatepicker from '../../../common/form/elements/required-datepicker';
import MultiSelect from '../../../common/form/multi-select';
import { saveGame, updateGame } from '../../../../actions/games';
import Divider from '../../../common/divider';
import GameLevelForm from '../game-levels/form/game-level-form';
import ImageUpload from '../../../common/form/elements/image-upload';

class GameForm extends Component {
  componentDidMount() {
    const { isEdit, model, dispatch } = this.props;

    if (!isEdit) {
      dispatch(actions.reset(model));
    }
  }

  groupIds = () => {
    const { groups } = this.props;

    if (!groups) {
      return [];
    }

    return  groups.map((group) => ({
      label: `${group.name}`,
      value: group.id
    }));
  };

  productIds = () => {
    const { products } = this.props;

    if (!products) {
      return [];
    }

    return  products.map((product) => ({
      label: `${product.sku_name} ${product.sku_code}`,
      value: product.id
    }));
  };

  handleSubmit = (payload) => {
    const { id, model, isEdit, dispatch } = this.props;

    if (isEdit) {
      dispatch(actions.submitFields(model, updateGame(id, payload)));
    } else {
      dispatch(actions.submitFields(model, saveGame(payload)));
    }
  };

  handleHasNoLevelsOnChange = () => {
    const { model, dispatch } = this.props;

    dispatch(actions.resetValidity(model));
  };

  render() {
    const { model, formValid, formData, hasNoLevels, links } = this.props;
    const startDate = formData.start_date;
    const endDate = formData.end_date;

    let banner;
    let background;

    if (links) {
      banner = links.banner;
      background = links.background;
    }

    return(
      <div className="container-fluid">
        <Form model={model} onSubmit={this.handleSubmit}>
          <Row>
            <Col md={12}>
              <RequiredInput
                label="Name"
                placeholder="Game Name"
                model=".name"
                controlId="game-name"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatepicker
                label="Start date"
                model={`${model}.start_date`}
                controlId="start-date"
                value={startDate}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredDatepicker
                label="End date"
                model={`${model}.end_date`}
                controlId="end-date"
                value={endDate}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <MultiSelect
                data={this.groupIds() || []}
                value={formData.group_ids}
                label="Eligible Groups"
                model={`${model}.group_ids`}
                controlId="group-ids"
                form={formData}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <MultiSelect
                data={this.productIds() || []}
                value={formData.product_ids}
                label="Product SKUs"
                model={`${model}.product_ids`}
                controlId="product-ids"
                form={formData}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ImageUpload
                label="Banner image"
                source={banner}
                sizeLimit={1024 * 1024}
                type={['image/png', 'image/jpg', 'image/jpeg']}
                model={`${model}.banner`}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ImageUpload
                label="Background image"
                source={background}
                sizeLimit={1024 * 1024}
                type={['image/png', 'image/jpg', 'image/jpeg']}
                model={`${model}.background`}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Control.checkbox
                model={`${model}.has_no_levels`}
                component={Checkbox}
                onChange={this.handleHasNoLevelsOnChange}
              >
                No levels
              </Control.checkbox>
            </Col>
          </Row>
          {hasNoLevels && <div>
            <Row>
            <Col md={12}>
              <RequiredInput
                label="Prize amount €"
                model={`.prize_amount`}
                type="number"
                min={0}
                step="any"
              />
            </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="Game Link"
                  model={`.game_link`}
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="Quantity"
                  model={`.no_level_quantity`}
                  type="number"
                  min={1}
                  step="1"
                />
              </Col>
            </Row>
          </div>}
          <Divider />
          <br />
          <Row>
            <Col>
              <GameLevelForm />
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton className="pull-right" arrow={false} disabled={!formValid}>
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.admin_game.$form.valid,
  isLoading: !state.games.fetched && state.games.fetching,
  formData: state.deep.admin_game,
  hasNoLevels: state.deep.admin_game.has_no_levels
});

export default connect(mapStateToProps)(GameForm);



// WEBPACK FOOTER //
// ./src/components/admin/games/form/game-form.jsx